export type CountryCodeMap = {
  [country: string]: string;
};

export const countryList: CountryCodeMap = {
    "Total": 'global',
    "Global": 'global',
    "Angola": "ao",
    "Benin": "bj",
    "Botswana": "bw",
    "Burkina Faso": "bf",
    "Cape Verde": "cv",
    "Chad": "td",
    "Congo": "cg",
    "Ghana": "gh",
    "Guinea-Bissau": "gw",
    "Kenya": "ke",
    "Liberia": "lr",
    "Madagascar": "mg",
    "Malawi": "mw",
    "Mali": "ml",
    "Mauritania": "mr",
    "Mauritius": "mu",
    "Mozambique": "mz",
    "Namibia": "na",
    "Niger": "ne",
    "Nigeria": "ng",
    "Senegal": "sn",
    "Sierra Leone": "sl",
    "South Africa": "za",
    "Swaziland": "sz",
    "Tanzania": "tz",
    "Uganda": "ug",
    "Zimbabwe": "zw",
    "All Countries": "255",
    "China (Mainland)": "cn",
    "China": "cn",
    "Albania": "al",
    "Austria": "at",
    "Belarus": "by",
    "Belgium": "be",
    "Bulgaria": "bg",
    "Croatia": "hr",
    "Czech Republic": "cz",
    "Denmark": "dk",
    "Estonia": "ee",
    "Finland": "fi",
    "France": "fr",
    "Germany": "de",
    "Greece": "gr",
    "Hungary": "hu",
    "Iceland": "is",
    "Ireland": "ie",
    "Italy": "it",
    "Latvia": "lv",
    "Lithuania": "lt",
    "Luxembourg": "lu",
    "Macedonia": "mk",
    "Malta": "mt",
    "Moldova": "md",
    "Netherlands": "nl",
    "Norway": "no",
    "Poland": "pl",
    "Portugal": "pt",
    "Romania": "ro",
    "Russia": "ru",
    "Slovakia": "sk",
    "Slovenia": "si",
    "Spain": "es",
    "Sweden": "se",
    "Switzerland": "ch",
    "Turkey": "tr",
    "Ukraine": "ua",
    "United Kingdom": "gb",
    "Worldwide": "#N/A",
    "China Hong Kong": "hk",
    "China Macau": "mo",
    "China Taiwan": "tw",
    "Taiwan": "tw",
    "Bengal": "bd",
    "India": "in",
    "Nepal": "np",
    "Pakistan": "pk",
    "Japan": "jp",
    "South Korea": "kr",
    "Algeria": "dz",
    "Bahrain": "bh",
    "Cyprus": "cy",
    "Egypt": "eg",
    "Iraq": "iq",
    "Israel": "il",
    "Jordan": "jo",
    "Kuwait": "kw",
    "Lebanon": "lb",
    "Morocco": "ma",
    "Oman": "om",
    "Qatar": "qa",
    "Saudi Arabia": "sa",
    "Tunisia": "tn",
    "United Arab Emirates": "ae",
    "Yemen": "ye",
    "Canada": "ca",
    "United States": "us",
    "Australia": "au",
    "Fiji": "fj",
    "New Zealand": "nz",
    "Papua New Guinea": "pg",
    "Solomon Islands": "sb",
    "Armenia": "am",
    "Azerbaijan": "az",
    "Bhutan": "bt",
    "Kazakhstan": "kz",
    "Kyrgyzstan": "kg",
    "Laos": "la",
    "Mongolia": "mn",
    "Sri Lanka": "lk",
    "Tajikistan": "tj",
    "Turkmenistan": "tm",
    "Uzbekistan": "uz",
    "Overseas": "#N/A",
    "Argentina": "ar",
    "Bahamas": "bs",
    "Belize": "bz",
    "Bolivia": "bo",
    "Brazil": "br",
    "Chile": "cl",
    "Colombia": "co",
    "Costa Rica": "cr",
    "Dominican Republic": "do",
    "Ecuador": "ec",
    "El Salvador": "sv",
    "Guatemala": "gt",
    "Guyana": "gy",
    "Honduras": "hn",
    "Jamaica": "jm",
    "Mexico": "mx",
    "Nicaragua": "ni",
    "Panama": "pa",
    "Paraguay": "py",
    "Peru": "pe",
    "Puerto Rico": "pr",
    "Suriname": "sr",
    "Trinidad and Tobago": "tt",
    "Uruguay": "uy",
    "Venezuela": "ve",
    "Brunei": "bn",
    "Cambodia": "kh",
    "Indonesia": "id",
    "Malaysia": "my",
    "Myanmar": "mm",
    "Philippines": "ph",
    "Singapore": "sg",
    "Thailand": "th",
    "Vietnam": "vn"
  }